<template>
  <div class="location-autocomplete" :class="wrapperClass">
    <div class="location-autocomplete__shell">
      <input
        ref="inputRef"
        type="text"
        :class="inputClass"
        :placeholder="inputPlaceholder"
        :value="inputValue"
        @focus="handleFocus"
        @input="handleInput"
        @keydown.capture="handleKeydown"
        autocomplete="off"
        v-bind="inputAttrs"
      />

      <button
        v-if="inputValue"
        type="button"
        class="location-autocomplete__clear"
        :aria-label="translate('Clear location')"
        @click="clearSelection"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import locationAutocompleteConfig from './locationAutocomplete.logic';

export default locationAutocompleteConfig;
</script>


<style scoped>
.location-autocomplete__shell {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.2rem 0.2rem;
  border-radius: 10rem;
  border: 1px solid #ffffff;
  background: #ffffff;
  box-shadow: 0 20px 45px rgba(14, 25, 71, 0.08);
}

.location-autocomplete__input {
  width: 100%;
  border: none;
  background: transparent;
  padding: 1.2rem 3.2rem;
  border-radius: 10rem;
  font-size: 1.4rem;
  color: #0b1c2c;
}

.location-autocomplete__input:focus {
  outline: none;
}

.location-autocomplete__clear {
  position: absolute;
  top: 50%;
  right: 1.6rem;
  transform: translateY(-50%);
  border: none;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  color: #0b1c2c;
  cursor: pointer;
}

.location-autocomplete__clear:hover {
  background: rgba(0, 0, 0, 0.12);
}

:global(.pac-item-nearby .pac-item-query) {
  font-weight: 600;
}

:global(.pac-item-nearby .pac-icon) {
  color: #2563eb;
}

:global(.pac-container) {
  border-radius: 1.6rem;
  box-shadow: 0 25px 45px rgba(10, 24, 64, 0.18);
  border: 1px solid rgba(37, 99, 235, 0.1);
  padding: 0.4rem 0;
}

:global(.pac-item) {
  padding: 0.8rem 1.6rem;
  font-size: 1.4rem;
  color: #0b1c2c;
}
</style>
